/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
} from "@mui/material"; // Material-UI components

import CloseIcon from "@mui/icons-material/Close";

// Dashboard example components
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";

// Functions from store
import { getFgReportHome } from "../../store";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ChartWithRange from "./ChartWithRange";
import FGChartWithRage from "./fgCardChart";

import Cookies from "universal-cookie";

const cookies = new Cookies();

const FgHomePageCard = ({
  getFgReportHome,
  getFgReportHomeReducer,
  startDate,
  endDate,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let role = loginDetails.data.role;

  let jwtToken = loginDetails?.jwt;
  const startDateIso = startDate ? startDate.toISOString().slice(0, 10) : "";

  const endDateIso = endDate ? endDate.toISOString().slice(0, 10) : "";

  useEffect(() => {
    getFgReportHome(startDateIso, endDateIso, jwtToken);
  }, [startDateIso, endDateIso]);

  const [fgTitle, setFgTitle] = useState("");

  const [fgData, setFgData] = useState([]);

  useEffect(() => {
    let data = getFgReportHomeReducer.fg.data
      ? getFgReportHomeReducer.fg.data.fgData
      : [];

    setFgData(data);

    setFgTitle(getFgReportHomeReducer?.fg?.data?.reportTitle);
  }, [getFgReportHomeReducer]);

  const chartData = {
    labels: fgData ? fgData.map((data) => String(data.label)) : [],
    datasets: {
      label: "Dispatched Units",
      data: fgData ? fgData.map((data) => String(data.dispatchedUnits)) : [],
    },
  };

  const [open, setOpen] = useState(false); // State for managing dialog visibility

  const handleOpen = () => {
    setOpen(true);
  };

  // Close the dialog
  const handleClose = () => {
    setOpen(false);
  };

  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const styles = {
    iconButton: {
      marginLeft: "10px",
      padding: "12px",
      borderRadius: "50%",
      backgroundColor: isHovered ? "#FB8C00" : "#FFA726", // Green background (hover state is darker)
      color: "white",
      boxShadow: isFocused
        ? "0 0 0 4px rgba(38, 143, 255, 0.5)" // Focus ring
        : "0 4px 12px rgba(0, 123, 255, 0.3)", // Default shadow
      transition: "all 0.3s ease-in-out", // Smooth transition for hover/scale/focus
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transform: isHovered ? "scale(1.1)" : "scale(1)", // Scale effect on hover
    },
  };

  return (
    <>
      {/* <ReportsLineChart
      color="warning"
      title={dataFromApi.reportTitle}
      // description={
      //   <>
      //     (<strong>+15%</strong>) increase in today sales.
      //   </>
      // }

      
      chart={chartData}
      
    /> */}
      <ReportsLineChart
        color="warning"
        title={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span
              style={{ fontSize: "16px", fontWeight: "500", color: "#333" }}
            >
              {fgTitle}
              
            </span>
            <IconButton
              style={styles.iconButton}
              onClick={handleOpen}
              onMouseEnter={() => setIsHovered(true)} // Hover effect (onMouseOver to onMouseEnter)
              onMouseLeave={() => setIsHovered(false)} // Hover effect (onMouseOut to onMouseLeave)
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
              aria-label="Home"
            >
              <AspectRatioIcon />
            </IconButton>
          </div>
        }
        chart={chartData}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            width: "95%",
            maxWidth: "100%",
            height: "100vh",
            margin: "auto",
            overflow: "hidden", // Prevent scrollbars
          },
        }}
      >
        <DialogTitle
          sx={{
            position: "relative", // Ensure that the close button can be positioned absolutely
          }}
        >
          {fgTitle}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* Indicator Boxes */}
            <div style={{ display: "flex", gap: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#34b933", 
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Product Units"
                />
                <span style={{ fontSize: 13 }}>Dispatch Units</span>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <div
                  style={{
                    width: 18,
                    height: 18,
                    background: "#ff0000", 
                    borderRadius: 4,
                    border: "1px solid #ccc",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  title="Dispatch Units"
                />
                <span style={{ fontSize: 13 }}>Product Units </span>
              </div>
            
            </div>
          </div>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 4,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            flex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* ⬇️ Your Chart */}
          <Box
            mb={2}
            width="100%"
            sx={{
              flex: 1,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <FGChartWithRage />
          </Box>
        </DialogContent>

        <DialogActions>
          {/* <Button onClick={handleClose} color="primary">
            Close
          </Button> */}
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getFgReportHomeReducer: state.getFgReportHomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFgReportHome: (startDate, endDate, jwtToken) =>
      dispatch(getFgReportHome(startDate, endDate, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FgHomePageCard);
